import PushCode from '@shell/connection/push/pushCode';

export type PushSourceKey = PushCode;

export const isPushSourceKey = (key: any): key is PushSourceKey => {
    return Object.values(PushCode)
        .map(code => String(code))
        .includes(String(key));
};

export default PushCode;
